var jobviteListModule = angular.module('jobviteListModule', []);

/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/
// Application controller
jobviteListModule.controller('JobviteCtrl', ['$scope', '$rootScope', 'jobviteService',
    function ($scope, $rootScope, jobviteService) {
        $scope.flags.showGridLoader = true;
        $scope.hideContent = true;
        jobviteService.getMetrics();
        jobviteService.getJobvites();
        $scope.$on('resultsAvailable', function (event, value) {
            $scope.hideContent = value;
            if (value === true) {
                $rootScope.$broadcast('expandGetStarted');
            }
        });
    }
]);

//get started controller
jobviteListModule.controller('GetStartedCtrl', ['$scope', '$rootScope', 'jobviteService',
    function ($scope, $rootScope, jobviteService) {
        $scope.ats = jobviteService.ats;
        $rootScope.$on('atsUpdate', function (atsValue) {
            $scope.ats = atsValue;
        });

        $scope.close = true;

        $scope.getStarted = function () {
            expandMinimize();
        };

        function expandMinimize() {
            $scope.close = !($scope.close);
            if ($scope.close === true) {
                $('.jv-plusMinus').text('+');
            } else {
                $('.jv-plusMinus').text('-');
            }
            $scope.getStarted.explode = !($scope.getStarted.explode);
        }
        $scope.$on('expandGetStarted', function () {
            expandMinimize();
            $rootScope.$broadcast('hideProceesing');
        });
    }
]);


//Metrics controller
jobviteListModule.controller('JobviteMetricsCtrl', ['$scope', '$rootScope',
    function ($scope, $rootScope) {
        $scope.totalBroadcast = $scope.totalSent = $scope.totalViews = 0;
        $scope.atsHide = true;
        $scope.sourceHide = true;

        $scope.closeInfo = function () {
            $('.jv-help').addClass('jv-hide');
        };

        $scope.helpIcon = function () {
            $('.jv-help').removeClass('jv-hide');
        };

        $scope.$on('metricsResults', function (event, results) {
            if (results.ats === false) {
                $scope.sourceHide = false;
            } else {
                $scope.atsHide = false;
            }
            if (results.counts.msent === 0 && results.counts.sent === 0 && results.counts.broadcasts === 0) {
                $rootScope.$broadcast('resultsAvailable', true);
            } else {
                $rootScope.$broadcast('resultsAvailable', false);
                $scope.totalBroadcast = results.counts.broadcasts;
                $scope.totalSent = results.counts.sent;
                $scope.totalViews = results.counts.views;
                $scope.totalApps = results.counts.apps;
                $scope.totalHires = results.counts.hires;
                $scope.totalClicks = results.counts.cta;
            }
        });

    }
]);

// Filter controller
jobviteListModule.controller('JobviteFilterCtrl', ['$scope', 'closeFilter', 'openFilter', 'jobviteService',
    function ($scope, closeFilter, openFilter, jobviteService) {
        var todaysDate = new Date();
        //var tDate = (todaysDate.getMonth() + 1)+ '/' + todaysDate.getDate() + '/' + (todaysDate.getFullYear());
        //var yDate = (todaysDate.getMonth() + 1)+ '/' + todaysDate.getDate() + '/' + (todaysDate.getFullYear()-1);
        $scope.messageTypeOptions = [{
                id: 'BROADCAST',
                text: i18n['JV_JOBVITE_BROADCAST']
            },
            {
                id: 'DIRECT',
                text: i18n['JV_JOBVITE_DIRECT_MESSAGE']
            }
        ];
        $scope.channelTypeOptions = [{
                id: 'FACEBOOK',
                text: i18n['JV_JOBVITE_FACEBOOK']
            },
            {
                id: 'TWITTER',
                text: i18n['JV_JOBVITE_TWITTER']
            },
            {
                id: 'LINKEDIN',
                text: i18n['JV_JOBVITE_LINKEDIN']
            },
            {
                id: 'EMAIL',
                text: i18n['JV_JOBVITE_EMAIL']
            },
            {
                id: 'JOBLINK',
                text: i18n['JV_JOBVITE_JOB_LINK']
            }
        ];
        $scope.actionTypeOptions = [{
                id: 'VIEWED',
                text: i18n['JV_JOBVITE_VIEWED']
            },
            {
                id: 'APPLIED',
                text: i18n['JV_JOBVITE_APPLIED']
            },
            {
                id: 'HIRED',
                text: i18n['JV_JOBVITE_HIRED']
            }
        ];

        $scope.filterObject = {};
        $scope.filterObject.channel = '';
        $scope.filterObject.messageType = '';
        $scope.filterObject.actionType = '';
        //$scope.filterObject.startDate = yDate;
        //$scope.filterObject.endDate = tDate;
        $scope.checkIfApply = false;

        $scope.makeCall = true;
        $scope.closeFilter = function () {
            closeFilter();
        };
        $scope.openFilter = function () {
            openFilter();
        };

        $scope.reset = function () {
            $scope.filterObject = {};
            //$scope.filterObject.startDate = yDate;
            //$scope.filterObject.endDate = tDate;
            $scope.filterObject.channel = '';
            $scope.filterObject.messageType = '';
            $scope.filterObject.actionType = '';
        };

        function checkToMakeCall() {
            if (new Date($scope.filterObject.startDate) > new Date($scope.filterObject.endDate)) {
                $scope.makeCall = false;
                $('.jv-dateError').removeClass('jv-hide');
            } else {
                $('.jv-dateError').addClass('jv-hide');
                $scope.makeCall = true;
            }
        }

        $scope.$watch('filterObject', function (newValue, oldValue) {
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            checkToMakeCall();
            $scope.savedChannel = $scope.filterObject.channel;
            if (newValue.messageType !== oldValue.messageType) {
                if (newValue.messageType === 'BROADCAST') {
                    $scope.channelTypeOptions = [{
                        id: 'FACEBOOK',
                        text: 'Facebook'
                    }, {
                        id: 'TWITTER',
                        text: 'Twitter'
                    }, {
                        id: 'LINKEDIN',
                        text: 'LinkedIn'
                    }, {
                        id: 'JOBLINK',
                        text: 'Job Link'
                    }];
                    if ($scope.savedChannel === 'EMAIL') {
                        $scope.filterObject.channel = '';
                    }
                } else if (newValue.messageType === 'DIRECT') {
                    $scope.channelTypeOptions = [{
                        id: 'FACEBOOK',
                        text: 'Facebook'
                    }, {
                        id: 'TWITTER',
                        text: 'Twitter'
                    }, {
                        id: 'LINKEDIN',
                        text: 'LinkedIn'
                    }, {
                        id: 'EMAIL',
                        text: 'Email'
                    }];
                    if ($scope.savedChannel === 'JOBLINK') {
                        $scope.filterObject.channel = '';
                    }
                } else if (newValue.messageType === '') {
                    $scope.channelTypeOptions = [{
                            id: 'FACEBOOK',
                            text: 'Facebook'
                        }, {
                            id: 'TWITTER',
                            text: 'Twitter'
                        }, {
                            id: 'LINKEDIN',
                            text: 'LinkedIn'
                        },
                        {
                            id: 'EMAIL',
                            text: 'Email'
                        }, {
                            id: 'JOBLINK',
                            text: 'Job Link'
                        }
                    ];
                }
            }
            if ($scope.makeCall === true) {
                var _args = angular.copy($scope.filterObject);
                if ($scope.filterObject.startDate && $scope.filterObject.startDate.trim() !== '' && $scope.filterObject.endDate && $scope.filterObject.endDate.trim() !== '') {
                    _args.startDate = $scope.filterObject.startDate;
                    _args.endDate = $scope.filterObject.endDate;
                }
                callSetFilters(_args);
            }
        }, true);

        function callSetFilters(_args) {
            if ($scope.filterObject.startDate && $scope.filterObject.startDate.trim() !== '') {
                _args.startDate = $scope.filterObject.startDate;
            }
            if ($scope.filterObject.endDate && $scope.filterObject.endDate.trim() !== '') {
                _args.endDate = $scope.filterObject.endDate;
            }
            jobviteService.setFilters(_args);
        }
    }
]);

// Header controller
jobviteListModule.controller('JobviteHeaderCtrl', ['$scope', 'jobviteService',
    function ($scope, jobviteService) {
        $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
        $scope.page = -1;

        $scope.$on('messageResults', function (event, results) {
            $scope.selection = {};
        });

        function deleteMessage(_messageIds) {
            const args = {};
            args.type = 'POST';
            args.action = 'delete';
            jobviteService.getJobvites(args);
        }

        $scope.items = [{
            name: 'Delete',
            id: '1'
        }];

        $scope.sortBy = [{
                name: 'Name',
                id: '0'
            },
            {
                name: 'Subject',
                id: '1'
            },
            {
                name: 'Type',
                id: '2'
            },
            {
                name: 'Date',
                id: '3'
            }
        ];

        $scope.change = function () {
            if ($scope.selection.name === 'Delete') {
                var _messageIds = jobviteService.getSelectedMessageIds();
                if (_messageIds.length > 0) {
                    $('.jv-selectionMsg').addClass('jv-hide');
                    deleteMessage(_messageIds);
                } else {
                    $('.jv-selectionMsg').removeClass('jv-hide');
                    $scope.selection = {};
                }
            }
        };

        $scope.sort = function () {
            if ($scope.sortSelection && $scope.sortSelection.name) {
                jobviteService.setSortBy($scope.sortSelection.name);
            }
        };


        $scope.$on('updatePage', function () {
            $scope.page = jobviteService.page;
        });

        function updatePaginationVars() {
            if ($scope.total !== 0) {
                $scope.start = ($scope.page * $scope.pageCount) + 1;
                $scope.end = ($scope.totalPages === $scope.page) ? $scope.total : ($scope.page * $scope.pageCount) + $scope.pageCount;
            } else {
                // total count is zero
                $scope.start = 0;
                $scope.end = 0;
            }
        }

        $scope.$on('paginationBroadcast', function () {
            $scope.total = jobviteService.total;
            $scope.pageCount = jobviteService.pageCount;
            $scope.totalPages = Math.ceil($scope.total / $scope.pageCount) - 1;
            $scope.page = jobviteService.page;
            updatePaginationVars();
        });

        $scope.paginate = function (next) {
            next = !!next;
            // check if there is no next/previous page.
            if (($scope.total === $scope.end && next) || ($scope.page === 0 && !next)) {
                return;
            }
            jobviteService.setPage(next ? $scope.page + 1 : $scope.page - 1);
        };
    }
]);


// Grid controller
jobviteListModule.controller('JobviteGridCtrl', ['$scope', '$rootScope', 'jobviteService',
    function ($scope, $rootScope, jobviteService) {
        var _result = null;
        $scope.jobvites = [];
        $scope.resultExists = false;
        $scope.atsHide = true;
        $scope.sourceHide = true;
        $scope.flags.showGridLoader = true;

        $scope.$on('hideProceesing', function () {
            $scope.flags.showGridLoader = false;
        });

        $scope.test = function (entity, value) {
            if (value !== i18n['JV_NA'] && value && value > 0) {
                $('.jv-userDetails').attr('key', entity);
                const args = {};
                args.action = 'getUserDetails';
                args.messageId = entity;
                args.page = 0;
                args.url = window.jvUrls.source + '/action/user/jobvites/' + entity + '/users';
                jobviteService.getSentJobvites(args, 'getUserDetails');
            }
        };

        $scope.openJobs = function (entity) {
            $('.jv-jobDetails').attr('key', entity);
            const args = {};
            args.action = 'getJobs';
            args.messageId = entity;
            args.page = 0;
            args.url = jvUrls.source + '/action/user/jobvites/' + entity + '/reqs';
            jobviteService.getJobs(args, 'getJobs');
        };

        $scope.$on('updateMessages', function (event, page) {
            $scope.flags.showGridLoader = true;
            getUpdatedMessages();
        });

        function getUpdatedMessages() {
            jobviteService.getJobvites();
        }

        function updateTheMessages(results) {
            var _backupResults = [];
            $scope.resultExists = 'null';
            $scope.resultExists = false;
            $scope.jobvites = [];
            jobviteService.ats = results.ats;
            $rootScope.$broadcast('atsUpdate', results.ats);
            if (results.ats === false) {
                $scope.sourceHide = false;
            } else {
                $scope.atsHide = false;
            }
            jobviteService.setPaginationVariables({
                total: parseInt((!!results.resultCount ? results.resultCount : 0)),
                pageCount: parseInt((!!results.pageCount ? results.pageCount : 10)),
                page: parseInt((!!results.page ? results.page : 0))
            });
            if (typeof results.resultList !== 'undefined' && results.resultList != null && results.resultList.length) {
                _backupResults = results.resultList;
                for (var i = 0, j = _backupResults.length; i < j; i++) {
                    $scope.jobvites[i] = results.resultList[i];
                    $scope.jobvites[i].flip = !(results.resultList[i].jobs > 1);
                    $scope.jobvites[i].showReqId = !(results.resultList[i].requisitionId && results.resultList[i].requisitionId.trim() !== '');

                    $scope.jobvites[i].extra = results.resultList[i].jobs - 1;
                    $scope.jobvites[i].id = i;
                    if ('BroadcastJoblink' === $scope.jobvites[i].type || 'Jobvite' === $scope.jobvites[i].type) {
                        $scope.jobvites[i].sent = i18n['JV_NA'];
                        $scope.jobvites[i].viewed = i18n['JV_NA'];
                    }
                    if ($scope.jobvites[i].channel === 'FACEBOOK') {
                        $scope.jobvites[i].channel = 'Facebook';
                    } else if ($scope.jobvites[i].channel === 'TWITTER') {
                        $scope.jobvites[i].channel = 'Twitter';
                    } else if ($scope.jobvites[i].channel === 'LINKEDIN') {
                        $scope.jobvites[i].channel = 'LinkedIn';
                    } else if ($scope.jobvites[i].channel === 'EMAIL') {
                        $scope.jobvites[i].channel = i18n['JV_JOBVITE_EMAIL'];
                    } else if ($scope.jobvites[i].channel === 'MOBILE_HIRING_TEAM_APP') {
                        $scope.jobvites[i].channel = 'Mobile-Hiring Team App';
                    } else {
                        $scope.jobvites[i].channel = i18n['JV_JOBVITE_JOB_LINK'];
                    }

                    $scope.resultExists = true;
                }
            }
            $scope.flags.showGridLoader = false;
        }

        $scope.$on('messageResults', function (event, results) {
            _result = results;
            updateTheMessages(_result);
        });

    }
]);

jobviteListModule.controller('JobviteOverlayController', ['$scope', 'jobviteService',
    function ($scope, jobviteService) {
        window.JV.Modal.initialize('jv-modalDialog');
        $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
        $scope.page = -1;

        function updatePaginationVars() {
            if ($scope.total !== 0) {
                $scope.start = ($scope.page * $scope.pageCount) + 1;
                $scope.end = ($scope.totalPages === $scope.page) ? $scope.total : ($scope.page * $scope.pageCount) + $scope.pageCount;
            } else {
                // total count is zero
                $scope.start = 0;
                $scope.end = 0;
            }
        }

        $scope.paginate = function (next) {
            next = !!next;
            if (($scope.total === $scope.end && next) || ($scope.page === 0 && !next)) {
                return;
            }
            var entity = $('.jv-userDetails').attr('key');
            const args = {};
            args.action = 'getUserDetails';
            args.messageId = entity;
            args.page = next ? $scope.page + 1 : $scope.page - 1;
            args.url = jvUrls.source + '/action/user/jobvites/' + entity + '/users';
            jobviteService.getSentJobvites(args);
        };

        $scope.isVisible = false;
        $scope.$on('showDeleteDialog', function (event, results) {
            $scope.jobviteDetails = [];

            $scope.total = results.resultCount;
            $scope.pageCount = results.pageCount;
            $scope.totalPages = Math.ceil($scope.total / $scope.pageCount) - 1;
            $scope.page = results.page;
            updatePaginationVars();

            if (typeof results.resultList !== 'undefined' && results.resultList != null && results.resultList.length) {
                $scope.page = results.page;
                $scope.pageCount = 10;
                for (var i = 0; i < results.resultList.length; i++) {
                    $scope.jobviteDetails = results.resultList;
                    $scope.jobviteDetails[i].firstName = !!results.resultList[i].firstName ? results.resultList[i].firstName : '-';
                    $scope.jobviteDetails[i].lastName = !!results.resultList[i].lastName ? results.resultList[i].lastName : '-';
                    $scope.jobviteDetails[i].email = !!results.resultList[i].email ? results.resultList[i].email : '-';
                    $scope.jobviteDetails[i].status = !!results.resultList[i].status ? results.resultList[i].status : '-';
                    $scope.jobviteDetails[i].viewDate = !!results.resultList[i].viewDate ? results.resultList[i].viewDate : '-';
                    $scope.jobviteDetails[i].applicationDate = !!results.resultList[i].applicationDate ? results.resultList[i].applicationDate : '-';
                    $scope.jobviteDetails[i].hireDate = !!results.resultList[i].hireDate ? results.resultList[i].hireDate : '-';
                }
            }
            $scope.showDeleteDialog();

        });

        $scope.$on('showNavigateAwayDialog', function () {
            $scope.showNavigateAwayDialog();
        });

        $scope.showDeleteDialog = function () {
            $scope.isVisible = true;
            window.JV.Modal.showAtHeight();
        };

        $scope.close = function () {
            $scope.isVisible = false;
            window.JV.Modal.hide();
        };
    }
]);

jobviteListModule.controller('JobOverlayController', ['$scope', 'jobviteService',
    function ($scope, jobviteService) {
        window.JV.ModalJob.initialize('jv-modalDialogJob');
        $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
        $scope.page = -1;

        function updatePaginationVars() {
            if ($scope.total !== 0) {
                $scope.start = ($scope.page * $scope.pageCount) + 1;
                $scope.end = ($scope.totalPages === $scope.page) ? $scope.total : ($scope.page * $scope.pageCount) + $scope.pageCount;
            } else {
                // total count is zero
                $scope.start = 0;
                $scope.end = 0;
            }
        }

        $scope.paginate = function (next) {
            next = !!next;
            if (($scope.total === $scope.end && next) || ($scope.page === 0 && !next)) {
                return;
            }
            var entity = $('.jv-jobDetails').attr('key');
            const args = {};
            args.action = 'getRequisition';
            args.messageId = entity;
            args.page = next ? $scope.page + 1 : $scope.page - 1;
            args.url = jvUrls.source + '/action/user/jobvites/' + entity + '/reqs';
            jobviteService.getJobs(args);
        };

        $scope.isVisible = false;
        $scope.$on('showJobs', function (event, results) {
            $scope.jobviteDetails = [];
            $scope.total = results.resultCount;
            $scope.pageCount = results.pageCount;
            $scope.totalPages = Math.ceil($scope.total / $scope.pageCount) - 1;
            $scope.page = results.page;
            updatePaginationVars();

            if (typeof results.resultList !== 'undefined' && results.resultList != null && results.resultList.length) {
                $scope.page = results.page;
                $scope.pageCount = 10;
                for (var i = 0; i < results.resultList.length; i++) {
                    $scope.jobviteDetails = results.resultList;
                    $scope.jobviteDetails[i].firstName = !!results.resultList[i].firstName ? results.resultList[i].firstName : '-';
                }
            }
            $scope.showJobs();
        });

        $scope.showJobs = function () {
            $scope.isVisible = true;
            window.JV.ModalJob.show();
        };

        $scope.close = function () {
            $scope.isVisible = false;
            window.JV.ModalJob.hide();
        };
    }
]);